import { h } from "preact";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";

import { getChatPriceABTesting } from "utils/ABTesting";
import {
  HOST_WEB_PRODUCTION,
  HOST_WEB_STAGING,
} from "utils/constants";
import { numberWithDot } from "utils/number";

import LawyerImages from "components/LawyerImages";
import Button from "components/Button";
import Img from "components/Img";
import ChatIcon from "images/ChatIcon.svg";

import messages from "../messages";

const Container = styled.div`
  width: 316px;
  display: flex;
  justify-content: center;
  padding: 46px;
  background-color: #003366;
  border-radius: 4px;
`;

const Content = styled.div`
  max-width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Price = styled.div`
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #f4c916;
`;

const Subtitle = styled.div`
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  color: white;
  margin-right: 10px;
`;

const Title = styled.div`
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 50px;
  letter-spacing: 0em;
  text-align: left;
  width: 211px;
  color: white;
`;

const RightSection = (props) => {
  let HOST = process.env.PREACT_APP_API_URL === 'production' ? HOST_WEB_PRODUCTION : HOST_WEB_STAGING;
  let category = props.matches.category
  let url = props.matches.url
  let version = props.matches.version
  let cohort = props.matches.cohort
  let CTA_URL = `${HOST}/partner/klinik/?utm_source=hukumonline&utm_medium=iframe&utm_campaign=chat&utm_content=uncategorized&category=${category}&url=${url}&cohort=${cohort}&version=${version}`;

  return (
    <Container>
      <Content>
        <LawyerImages />
        <Title id="title">
          <FormattedMessage {...messages.consultation_30_minutes} />
        </Title>
        <div style={{ display: "flex" }}>
          <Price id="price">
            <span style={{ fontWeight: '500', textDecoration: 'line-through', color: '#ffffff', marginRight: '4px' }}>{"Rp 50.000"}</span>
            {`Rp ${numberWithDot(getChatPriceABTesting(props))}`}
          </Price>
        </div>
        <Button
          href={CTA_URL}
          blank="_blank"
          color="yellow"
          size="large"
          style={{ boxShadow: "none" }}
        >
          <div
            style={{
              display: "inline-block",
              width: "30px",
              marginRight: "10px",
            }}
          >
            <Img alt="Chat Icon" src={ChatIcon} style={{ width: "20px" }} />
          </div>
          <FormattedMessage {...messages.cta} />
        </Button>
      </Content>
    </Container>
  );
};

export default RightSection;
